export default "__VITE_ASSET__goxjJkbE__"